import request from "@/utils/request";
const qs = require("qs");
import { MLMCore } from "@/utils/requestApi";

// progresss
export function loginStored(data) {
  return request({
    url: MLMCore() + "/login/stored",
    method: "POST",
    data: qs.stringify(data)
  });
}
export function updateProfile(data) {
  return request({
    url: MLMCore() + "/account/update_profile",
    method: "POST",
    data: qs.stringify(data)
  });
}

export function getInfo() {
  return request({
    url: MLMCore() + "/account/profile",
    method: "get"
  });
}

export function logout() {
  return request({
    url: MLMCore() + "/account/logout",
    method: "get"
  });
}

export function registasiStroed(data) {
  return request({
    url: MLMCore() + "/patient/registration/stored",
    method: "POST",
    data: qs.stringify(data)
  });
}

export function forgotPassword(data) {
  return request({
    url: MLMCore() + "/login/forgot_password",
    method: "POST",
    data: qs.stringify(data)
  });
}
// end progresss

//fungsi untuk simpan profile admin
export function updateProfileAdminStored(data) {
  return request({
    url: "/user/info/update_profile_admin_stored",
    method: "POST",
    data,
    transformRequest: [
      function(data) {
        const serializedData = [];
        for (const k in data) {
          if (data[k]) {
            serializedData.push(`${k}=${encodeURIComponent(data[k])}`);
          }
        }

        return serializedData.join("&");
      }
    ]
  });
}

// //fungsi untuk simpan password admin
export function updatePasswordAdminStored(data) {
  return request({
    url: "/user/info/update_password_admin_stored",
    method: "POST",
    data,
    transformRequest: [
      function(data) {
        const serializedData = [];
        for (const k in data) {
          if (data[k]) {
            serializedData.push(`${k}=${encodeURIComponent(data[k])}`);
          }
        }

        return serializedData.join("&");
      }
    ]
  });
}
export function checkSubdomain(data) {
  return request({
    url: "/auth/my_admin/check_subdomain",
    method: "POST",
    data: qs.stringify(data) // untuk array data post
  });
}

export function login(data) {
  return request({
    url: "/auth/my_admin/login",
    method: "POST",
    data,
    transformRequest: [
      function(data) {
        const serializedData = [];
        for (const k in data) {
          if (data[k]) {
            serializedData.push(`${k}=${encodeURIComponent(data[k])}`);
          }
        }

        return serializedData.join("&");
      }
    ]
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js